import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';

import { API_LINK } from '../../constants';
import { getUserProgramsFullRequest } from '../reducers/userProgramsFull';
import { contentItemRequest } from '../reducers/contentList';
import { saveBookmarksFailure, saveBookmarksRequest, saveBookmarksSuccess } from '../reducers/annotations';

const API = `${API_LINK}api/user/`;

function* saveBookmarkAxios() {
  const state = yield select(fullState => fullState);
  const user_id = state.loginReducer.user.userId;
  const {
    token,
  } = state.loginReducer;
  const current_page = 30;
  const {
    selectedContentId: component_id,
  } = state.userProgramsFullReducer;

  const {
    learnerBookmarks: bookmark_json,
  } = state.annotationsReducer;
  /*const name = !state.form.saveEdit.values
    ? state.savedVersionsReducer.learnerVersions.find(
      version => version.versionId === state.userProgramsFullReducer.selectedUserVersion,
    ).name
    : state.form.saveEdit.values.Version;*/
    

   
  const response = yield call(() =>
    axios({
      method: 'post',
      url: `${API}${user_id}/storeBookmark`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        user_id,
        component_id,
        bookmark_json,
        current_page,
      },
    }),
  );
  
  return response;
}

function* workerSaveBookmarkSaga() {
  try {
    
    const response = yield call(saveBookmarkAxios);

    const responseFromSaveBookmark = response.data;
   
    if (response.status === 200) {
      yield put(saveBookmarksSuccess(responseFromSaveBookmark));
      yield put(contentItemRequest());
    }
    if (response.status === 561) {
      yield put(saveBookmarksFailure(response.message));
    }
    if (response.status === 562) {
      yield put(saveBookmarksFailure(response.message));
    }
  } catch (error) {
    
    yield put(saveBookmarksFailure(error));
  }
}

export function* watcherSaveBookmarkSaga() {
  yield takeLatest(saveBookmarksRequest().type, workerSaveBookmarkSaga);
}
